<template>
  <div class="o-card">
    <loading v-if="isLoading"></loading>
    <no-auth v-else-if="!hasAuthorize.getById"></no-auth>
    <not-found v-else-if="!cycle"></not-found>
    <div v-else>
      <PageTitle
        :title="
          $t('cycle.copy', {
            serialNo: cycle.serialNumber,
          })
        "
        :description="$t('cycle.copyDescription')"
      ></PageTitle>
      <CycleForm :cycle="cycle"></CycleForm>
    </div>
  </div>
</template>

<script>
import Loading from "../Base/Loading/Loading.vue";
import CycleForm from "../Cycles/CycleForm/index.vue";
import PageTitle from "@/components/Shared/PageTitle/index.vue";
import NotFound from "../Base/NotFound.vue";
import authorize from "../Cycles/authorize";
export default {
  components: { Loading, CycleForm, NotFound, PageTitle },
  mixins: [authorize],
  data() {
    return {
      cycleId: null,
      isLoading: true,
      cycle: null,
    };
  },
  methods: {
    async getCycle() {
      this.isLoading = true;
      const response = await this.$store.dispatch("getCycleById", {
        id: this.$route.params.cycleId,
      });
      if (response.message === "OK") {
        this.cycle = response.data;
      }
      this.isLoading = false;
    },
  },
  mounted() {
    this.getCycle();
  },
};
</script>

<style></style>
